import { render, staticRenderFns } from "./JobPriorityEditor.vue?vue&type=template&id=76b7551a&"
import script from "./JobPriorityEditor.vue?vue&type=script&lang=ts&"
export * from "./JobPriorityEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports